module.exports = __webpack_public_path__ + "img/type1_check.1869f05f.png";